import { IRewardsBalanceResponse } from '../rewardsClub.interface';

export const createCurrencyDropdownOptions = (allRewards: IRewardsBalanceResponse[]): string[] => {
    return allRewards?.map((reward) => reward.currency) ?? [];
};
